document.addEventListener("DOMContentLoaded", function() {
    // GTM scroll detection
    const isSveltePage = document.getElementById('svelte-main-app') || document.getElementById('svelte-faq-app');
    
    // 타겟이 없으면 일반 Shopify 페이지이므로 스크립트 종료 (GTM 기본 스크롤 기능에 맡김)
    if (!isSveltePage) return;

    // 2. 스크롤 추적 로직 시작
    const thresholds = [10, 25, 50, 75, 90];
    let firedThresholds = new Set();
    let ticking = false;

    function handleScroll() {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const scrollTop = window.scrollY || document.documentElement.scrollTop;
          
          // 핵심: 스크롤할 때마다 scrollHeight를 다시 계산하므로 Svelte가 데이터를 늦게 불러와도 문제없음
          const scrollHeight = document.documentElement.scrollHeight;
          const clientHeight = document.documentElement.clientHeight;

          // 페이지 길이가 브라우저 창보다 짧으면 스크롤 이벤트 무시
          if (scrollHeight <= clientHeight) {
            ticking = false;
            return;
          }

          const scrollPercent = (scrollTop / (scrollHeight - clientHeight)) * 100;

          thresholds.forEach(threshold => {
            if (scrollPercent >= threshold && !firedThresholds.has(threshold)) {
              firedThresholds.add(threshold); // 중복 발송 방지
              
              // GTM으로 이벤트 푸시
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                'event': 'custom_scroll_depth',
                'custom_percent_scrolled': threshold
              });
            }
          });
          
          ticking = false;
        });
        ticking = true;
      }
    }

    // 스크롤 이벤트 리스너 등록
    window.addEventListener('scroll', handleScroll);
    
    // 페이지 로딩 직후(Svelte가 초기 렌더링을 마쳤을 때) 1회 체크
    setTimeout(handleScroll, 500);
});